import type { FC } from "react";
import React from "react";

import { ErrorView } from "@react/foundation/placeholder";

export const ErrorViewDemo: FC = () => (
  <ErrorView
    actionLabel="Retry"
    description="We couldn't load your data. Please try again."
    title="Failed to load"
  />
);
